module.exports = __webpack_public_path__ + "img/TV_clean_box22.5046b9d3.jpg";